import React from 'react';
import { Link } from 'react-router-dom';
import  MainLayout from '../../../shared/layouts/MainLayout';
import { Card } from '../../../shared/components';
import {
  FileText,
  Archive,
  ExclamationTriangle,
  Calendar2,
  ArrowLeftRight,
  BarChart
} from 'react-bootstrap-icons';

const reportCards = [
  {
    title: 'Issue Report',
    description: 'Track medicine issues with detailed transaction history',
    icon: <FileText className="w-8 h-8" />,
    path: '/reports/issue',
    color: 'bg-blue-500'
  },
  {
    title: 'Stock Availability',
    description: 'View current stock levels and status',
    icon: <Archive className="w-8 h-8" />,
    path: '/reports/stock',
    color: 'bg-green-500'
  },
  {
    title: 'Low Stock Alert',
    description: 'Medicines that need reordering',
    icon: <ExclamationTriangle className="w-8 h-8" />,
    path: '/reports/low-stock',
    color: 'bg-yellow-500'
  },
  {
    title: 'Expiry Report',
    description: 'Track medicines approaching expiry',
    icon: <Calendar2 className="w-8 h-8" />,
    path: '/reports/expiry',
    color: 'bg-red-500'
  },
  {
    title: 'Movement Summary',
    description: 'Overview of all stock movements',
    icon: <ArrowLeftRight className="w-8 h-8" />,
    path: '/reports/movement',
    color: 'bg-purple-500'
  },
  {
    title: 'Top Consumed',
    description: 'Most frequently used medicines',
    icon: <BarChart className="w-8 h-8" />,
    path: '/reports/top-consumed',
    color: 'bg-indigo-500'
  }
];

const ReportsDashboardPage = () => {
  return (

      <div className="container mx-auto px-4 py-8">
        <h1 className="text-2xl font-bold mb-6">Reports Dashboard</h1>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reportCards.map((report, index) => (
            <Link to={report.path} key={index}>
              <Card className="hover:shadow-lg transition-shadow cursor-pointer">
                <div className="p-6">
                  <div className={`${report.color} text-white w-16 h-16 rounded-lg flex items-center justify-center mb-4`}>
                    {report.icon}
                  </div>
                  <h3 className="text-lg font-semibold mb-2">{report.title}</h3>
                  <p className="text-gray-600 text-sm">{report.description}</p>
                </div>
              </Card>
            </Link>
          ))}
        </div>
      </div>

  );
};

export default ReportsDashboardPage;